export type ApiEnvelope<T> = {
  ok: boolean;
  requestId: string;
  data?: T;
  error?: { code: string; message: string };
};

export async function apiJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  const body = await response.json() as ApiEnvelope<T>;
  if (!response.ok || !body.ok || body.data === undefined) {
    throw new Error(body.error?.message || `Request failed (${response.status})`);
  }
  return body.data;
}

export function createIdempotencyKey(prefix: string): string {
  return `${prefix}-${crypto.randomUUID()}`;
}
